import { z } from 'zod';
import { IsoDateSchema, TrackIdSchema, YearMonthSchema } from './common.js';
import { GrowthColumnSchema, PeriodSchema } from './periods.js';
import { SelectorsSchema } from './selectors.js';
export const EventClassSchema = z.enum(['release', 'campaign', 'revival', 'unattributed']);
export const CellNoteSchema = z.object({
    from: z.number(),
    to: z.number(),
    releaseTiming: z.enum(['inside_window', 'first_full_year']).optional(),
    events: z.array(z.object({
        month: YearMonthSchema,
        class: EventClassSchema,
        trackTitle: z.string(),
        dev: z.number(),
        cause: z.string().optional(),
        sourceUrl: z.string().optional(),
    })),
});
/** Vintage of a track relative to the catalogue year: before it, from it onward, or no release date at all. */
export const VintageSchema = z.enum(['catalogue', 'new', 'unknown']);
export const AGGREGATE_KEYS = ['topN', 'other', 'total', 'catalogue', 'new', 'unknown'];
export const BreakdownRowSchema = z.object({
    kind: z.enum(['track', 'aggregate']),
    /** trackId for tracks; one of AGGREGATE_KEYS for aggregates. */
    key: z.string(),
    label: z.string(),
    rank: z.number().int().positive().optional(),
    trackCount: z.number().int().optional(),
    note: z.string().optional(),
    releaseDate: IsoDateSchema.nullable().optional(),
    releaseYear: z.number().int().nullable().optional(),
    /** Release date comes from a researched override. */
    ovr: z.boolean().optional(),
    vintage: VintageSchema.optional(),
    /** Share of the basis-window total across all tracks (0..1). */
    shareOfBasis: z.number(),
    /** Territory-resolved stream counts per period key. */
    levels: z.record(z.string(), z.number()),
    /** Growth per growth column key; null when the base is not positive. */
    growth: z.record(z.string(), z.number().nullable()),
    /** Hover notes, only where |growth| >= 0.5. */
    flags: z.record(z.string(), CellNoteSchema),
});
export const BreakdownSchema = z.object({
    selectors: SelectorsSchema,
    anchor: IsoDateSchema,
    periods: z.array(PeriodSchema),
    basisWindow: z.object({ start: IsoDateSchema, end: IsoDateSchema, label: z.string() }),
    denominator: z.number(),
    growthColumns: z.array(GrowthColumnSchema),
    rows: z.array(BreakdownRowSchema),
    notes: z.object({
        unknownReleaseYear: z.number().int(),
        overrides: z.number().int(),
        exUsFloored: z.boolean(),
    }),
});
export { TrackIdSchema };
//# sourceMappingURL=breakdown.js.map